<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="im-message-container tuwen-mobile-container"
       :class="isMobileVerticalLayout ? 'isMobileVerticalLayout' : 'isMobileHorizontalLayout'">
    <div class="content-top-chat">
      <div class="message-container" ref="box">
     <el-timeline
        class="myTimeLine myTimeLineH5"
        v-if="messageList.length > 0 && chatRoomEnable"
      >
        <!-- // <el-icon><Clock /></el-icon> -->
        <el-timeline-item
          v-for="(message, index) in messageList"
          :key="index"
          :timestamp="getMessageTime(message)"
          placement="top"
          :icon="'el-icon-timer'"
          :type="'primary'"
          :hollow="true"
        >
          <el-card>
            <div class="message-warp">
              <div class="message-content">
                <span v-for="(item, index) in message.renderContent" :key="index">
                  <p :key="message.id + '_' + index" v-if="item.content" v-html="item.content"></p>
                </span>
              </div>

              <!-- 图片内容 -->
              <div class="img-content" v-if="message.imageUrl.length">
                <el-image
                  :class="'liveImg liveImg' + message.imageUrl.length"
                  v-for="(item, index) in message.imageUrl" :key="index"
                  :src="item.thumburl"
                  :preview-src-list="[item.url]"
                >
                </el-image>
              </div>

              <span class="top-icon"
                v-if="message.stickyTop > 0"
              >
                置顶
              </span>

  <!--
    v-if="message.state === 'fail'"
  -->
              <!-- <div class="message-send-fail" @click="reSendMessage(message)">
                <svg-icon class="icon-style" icon-name="error"></svg-icon>
              </div> -->
            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>

      </div>
      <!-- <p class="disabled-tips" v-if="!chatRoomEnable">{{ '聊天室暂时关闭' }}</p> -->
    </div>
    <div class="send-message-container">
      <div class="emojis-popover" ref="emojiPopover" v-show="showEmojiPopover">
        <div class="emojis">
          <div class="emoji" v-for="emoji in emojiName" :key="emoji" @click="chooseEmoji(emoji)">
            <img :src="emojiUrl + emojiMap[emoji]"/>
          </div>
        </div>
        <div class="emojis-popover-arrow"></div>
      </div>

      <div class="content-bottom" :class="chatRoomEnable && sendMsgEnable ? '' : 'disabled'">

        <span class="icon-button" ref="emojiIcon" @click="toggleShowEmojis">
          <svg-icon class="emoji-icon" icon-name="emoji"></svg-icon>
        </span>

        <div class="content-bottom-input">
          <!--
            @keyup.enter="handleSendMsg"
           -->
          <input class="input" ref="input" type="text" v-model="inputMsg" :placeholder="inputPlaceHolder"
                 :disabled="isLiveEnded || showLoginAttention " required="required" />
        </div>
        <div class="send-btn" @click="handleSendMsg" v-if="!showLoginAttention">{{ $t('Send') }}</div>
        <div class="login-attention" v-if="showLoginAttention">
          <span>{{ $t('Current visitor status') }}</span>
          <a @click="handleLogin">{{ $t('login') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bim from './bim.js';
export default {
  name: 'tuwenMobile',
  mixins: [bim],
  props: {
    isMobileVerticalLayout: {
      type: Boolean,
    },
    isMobileHorizontalLayout: {
      type: Boolean,
    },
  },
  data() {
    return {
      showEmojiPopover: false,
    };
  },
  methods: {
    toggleShowEmojis() {
      this.showEmojiPopover = !this.showEmojiPopover;
    },
    handleHideEmojiPopover(event) {
      if (!this.$refs.emojiIcon.contains(event.target) && !this.$refs.emojiPopover.contains(event.target)) {
        this.showEmojiPopover = false;
      }
    },
  },
  beforeCreate() {
    document.addEventListener('click', event => this.handleHideEmojiPopover(event));
  },
  beforeDestroy() {
    document.removeEventListener('click', event => this.handleHideEmojiPopover(event));
  },
};
</script>

<style lang="stylus" scoped>
@import './index.styl';

.im-message-container
  width 100%
  height calc(100% - 52px)
  .content-top-chat
    position relative
    width 320px
    height calc(100% - 18px)
    margin 10px 0 8px 18px
    border-radius 10px
    color $fontColor
    font-size 14px
    overflow hidden
    pointer-events all
    .message-container
      position absolute
      bottom 0
      width calc(100% + 10px)
      max-height 100%
      overflow auto

  .send-message-container
    position fixed
    bottom 20px
    width 100%
    .emojis-popover
      position absolute
      background #FFF
      min-width 150px
      max-width 400px
      width calc(100% - 8px)
      border-radius 4px
      border 1px solid #EBEEF5
      padding 12px
      color #606266
      line-height 1.4
      text-align justify
      font-size 14px
      box-shadow 0 2px 12px 0 rgb(0 0 0 / 10%)
      word-break break-all
      transform translateX(8px) translateY(-100%) translateY(-8px)
      pointer-events all
      .emojis
        height 170px
        max-width 400px
        overflow scroll
        .emoji
          height 30px
          width 30px
          float left
          box-sizing border-box
          img
            width 30px
            height 30px
      &::after
        content ''
        width 0
        height 0
        border 6px transparent solid
        border-top-color #FFF
        position absolute
        left 18px
        top 100%
    .content-bottom
      width 60%
      min-width 217px
      max-width 320px
      height 32px
      border-radius 16px
      background-color $IMThemeColor
      display flex
      align-items center
      border 1px solid rgba(255,255,255,0.20)
      padding 0 2px 0 6px
      margin-left 15px
      pointer-events all
      position relative
      span.icon-button
        cursor pointer
        display flex
        .emoji-icon
          width 20px
          height 20px
          fill $emojiIconColor
      div.content-bottom-input
        text-align left
        position relative
        margin 0 6px
        flex-grow 1
        .input
          color $fontColor
          top 0
          right 0
          width 100%
          height 100%
          background-color $IMThemeColor
          font-size 14px
          border none
          outline none
          resize none
      .send-btn
        padding 2px 4px
        background-color $highLightColor
        width 50px
        border-radius 16px
        height 26px
        line-height 24px
        font-size 14px
        color $controlFontColor
      .login-attention
        position absolute
        left 40px
        font-size 14px
        color $grayFontColor
        line-height 32px
    .content-bottom.disabled
        border-color $disabledColor !important
        .send-btn
          background-color $disabledColor !important
          cursor not-allowed !important
  // 竖屏
  &.isMobileVerticalLayout
    .content-top-chat
      width calc(100% - 30px)
      .message-container
        .single-message-h5
          .message-content-container
            // padding-left 0
            .user-name
              color $grayFontColor
              &.oneself
                color $highLightColor
    .send-message-container
      .content-bottom
        border-color $lineColor
        width calc(100% - 30px)
        max-width none
  // 横屏
  &.isMobileHorizontalLayout
    .content-top-chat
      width calc(100% - 30px)
      .message-container
        .single-message-h5
          .message-content-container
            // padding-left 0
            .message-content
              color $horizontalLayoutFontColor
    .send-message-container
      .content-bottom
        border-color $lineColor
        width calc(100% - 30px)
        max-width none
</style>

<i18n>
{
	"en": {
		"Chat now": "Chat now！",
    "Type a message": "Type a message",
    "Current visitor status": "Visitor status, please ",
    "login": "login",
    "Send": "Send",
    "Live room does not exist": "Live room does not exist"
	},
	"zh": {
		"Chat now": "快来互动吧！",
    "Type a message": "说点什么",
    "Current visitor status": "当前为游客身份，请先",
    "login": "登录",
    "Send": "发送",
    "Live room does not exist": "直播间不存在"
	}
}
</i18n>
